function convertToIST(utcTimestamp) {
  const date = new Date(utcTimestamp);

  const time = new Intl.DateTimeFormat("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  }).format(date);

  const now = new Date();
  const todayIST = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
  const targetIST = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

  const startOfToday = new Date(todayIST.getFullYear(), todayIST.getMonth(), todayIST.getDate());
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfToday.getDate() - 1);
  const startOfTarget = new Date(targetIST.getFullYear(), targetIST.getMonth(), targetIST.getDate());

  let formattedDate = new Intl.DateTimeFormat("en-GB").format(targetIST);
  if (startOfTarget.getTime() === startOfToday.getTime()) formattedDate = "Today";
  if (startOfTarget.getTime() === startOfYesterday.getTime()) formattedDate = "Yesterday";

  return { time, date: formattedDate };
}

export default convertToIST;